import React from "react";
import AdditionalCleaningPage from "./AdditionalCleaningPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface AdditionalPageContainerProps extends RouteProps, withValidUserRoleProps {}

const AdditionalPageContainer = (props: AdditionalPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <AdditionalCleaningPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(AdditionalPageContainer);
